export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6195.051cf87f.jpg";